export const INFORMATION_TYPE = {
  IMPORTANT: "important",
  SYSTEM: "system",
  TENANT: "tenant",
};

export const CONVERT_STATUS = {
  COMPLETE: "complete",
  IN_PROGRESS: "in_progress",
  ERROR: "error",
  CANCEL: "cancel",
};

export const DOCUMENT_KEYS = {
  ACCEPTANCE_ACTIVITY: "acceptance_activity",
  LIFE_SUPPORT: "life_support",
  ANY_TIME: "any_time",
  RETIREMENT: "retirement",
};

export enum EOrganizationStatus {
  ACTIVE = "active",
  ARCHIVED = "archived",
  DELETED = "deleted",
}

export enum EAdminUserAccountStatus {
  INVITATION_SENT = "invitation_sent",
  ACCOUNT_CONFIGURED = "account_configured",
  PASSWORD_RESET = "password_reset",
  SUSPENDED = "suspended",
}

export enum EUserAccountStatus {
  INVITATION_SENT = "invitation_sent",
  ACCOUNT_CONFIGURED = "account_configured",
  PASSWORD_RESET = "password_reset",
  SUSPENDED = "suspended",
}

export enum EAdminUserRole {
  SUPER_ADMIN = "super_admin",
  ADMIN = "admin",
  GENERAL = "general",
}

export enum EMenuId {
  HOME = "home",
  CS_FUNCTIONS = "cs-functions",
  SYSTEM_MANAGEMENT = "system-management",
}

export enum EAdminUserStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export enum EUserStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export enum EOrganizationType {
  RSO = "rso",
  COMPANY = "company",
  OTHER = "other",
}

export enum ELoginPurpose {
  CS_SUPPORT = "cs_support",
  PROXY_OPERATION = "proxy_operation",
  BUG_CHECK = "bug_check",
  OTHER = "other",
}

export enum EUserProductContractStatus {
  ACTIVE = "active",
  DE_ACTIVE = "de_active",
}
